import React from 'react';

const BoatList = ({ boats, onSelectBoat }) => {
  return (
    <div className="p-6">
      <h3 className="text-xl font-semibold text-gray-800 mb-6">Tus Embarcaciones</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {boats.map((boat) => (
          <div
            key={boat.id}
            onClick={() => onSelectBoat(boat)}
            className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
          >
            <div className="bg-blue-50 p-4">
              <h4 className="font-medium text-blue-800">{boat.name}</h4>
            </div>
            <div className="p-4">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Escaneos:</span>
                <span className="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full">
                  {boat.scans.length}
                </span>
              </div>
              <div className="mt-4 flex justify-end">
                <button className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center">
                  Ver detalles
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoatList;

// DONE